import { useMutation } from "@tanstack/react-query";

import { createServiceResponseSchema, publicApi } from "@/api/axios";
import type { SetPasswordRequest } from "@/domains/profile/models/types";
import { useSessionStore } from "@/stores";
import { setPasswordResponseSchema } from "../models/schemas";

export const useSetPassword = () => {
  const setSession = useSessionStore((s) => {
    return s.setSession;
  });

  return useMutation({
    mutationFn: setPassword,
    onSuccess: ({ accessToken, expiresIn, tokenType }) => {
      setSession({
        token: accessToken,
        type: tokenType,
        expiresIn,
      });
    },
  });
};

const setPassword = async ({
  password,
  passwordConfirmation,
  variantRevisionUuid,
}: SetPasswordRequest) => {
  const response = await publicApi.patch(`/profilings/${variantRevisionUuid}/password`, {
    password,
    passwordConfirmation,
  });

  return createServiceResponseSchema(setPasswordResponseSchema).parse(response.data).data;
};
